import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-sm login-form d-flex flex-column mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_card, { class: "mb-1" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_form, {
          onChange: _ctx.checkForm,
          autoComplete: "off",
          action: "",
          onKeydown: _withKeys(_withModifiers(_ctx.handleLogin, ["prevent"]), ["enter"]),
          "data-test": "loginBForm"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_b_form_group, {
                id: "username",
                description: "Tu username aquí, por favor",
                label: "username",
                "label-for": "input-username",
                "valid-feedback": "¡Gracias!",
                "invalid-feedback": _ctx.floatingInvalidFeedbackUsername,
                state: _ctx.floatingStateUsername,
                floating: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_input, {
                    id: "input-username",
                    modelValue: _ctx.username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                    state: _ctx.floatingStateUsername,
                    trim: "",
                    placeholder: "Entra tu username, por favor!"
                  }, null, 8, ["modelValue", "state"])
                ]),
                _: 1
              }, 8, ["invalid-feedback", "state"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_b_form_group, {
                id: "password",
                description: "Tu contraseña aquí, por favor",
                label: "contraseña",
                "label-for": "input-password",
                "valid-feedback": "Thank you!",
                "invalid-feedback": _ctx.floatingInvalidFeedbackPassword,
                state: _ctx.floatingStatePassword,
                floating: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_input, {
                    id: "input-password",
                    type: "password",
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    state: _ctx.floatingStatePassword,
                    trim: "",
                    placeholder: "Entra tu contraseña, por favor!"
                  }, null, 8, ["modelValue", "state"])
                ]),
                _: 1
              }, 8, ["invalid-feedback", "state"])
            ])
          ]),
          _: 1
        }, 8, ["onChange", "onKeydown"])
      ]),
      _: 1
    }),
    _createVNode(_component_b_button, {
      disabled: _ctx.isDisabled,
      class: _normalizeClass(_ctx.isDisabled ? 'disabled login-form--submit-button' : 'login-form--submit-button'),
      onClick: _ctx.handleLogin,
      type: "submit",
      pill: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.isWrong ? "Incorrecto" : "Ingresar"), 1)
      ]),
      _: 1
    }, 8, ["disabled", "class", "onClick"])
  ]))
}